<template>
    <div>
        <div class="container">
            <el-scrollbar :height="800" :noresize="true">
                <div class="down-item2">
                    第一步：下载承包数据导入Excel模板，在模板中录入要导入的承包数据（注意：不能修改模板表头以及随意添加列）（<a title="点击下载承包数据导入Excel模板" class="downStyle" :href="url0">点击下载承包数据导入Excel模板</a>）
                </div>
                <img :src="pic01" class="sm-image">
                <div class="down-item2">
                    第二步：下载数据导入工具包，然后解压，在目录中找到“土地承包数据导入.exe”，最后双击打开。
                    （<a title="点击下载数据导入工具包" class="downStyle" :href="url">点击下载数据导入工具包</a>）
                </div>
                <img :src="pic02" class="sm-image" style="height:400px;">
                <div class="down-item2">
                    第三步：“选择”已经处理好的承包数据Excel，然后点击“开始导入”，最后等待导入结果提示
                </div>
                <img :src="pic03" class="sm-image" style="height:350px;">
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
  import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped >
@import url(./assets/style/style.less);
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}

</style>